import { getCoreApi } from '@/utility/getCoreApi';

import apiRequest from './apiRequest';

export interface ILocalityPriceAggregations {
  max_price: number;
  min_price: number;
  p02_price: number;
  p99_price: number;
  rental_count: number;
}
export const getLocalityPriceAggregation = ({ lat, lng }: { lat: number; lng: number }) => {
  if (lng && lat) {
    const url = `${getCoreApi()}/pricing/aggregate?lat=${lat}&lng=${lng}`;
    return apiRequest<ILocalityPriceAggregations>({ url });
  }
  return null;
};
